import React, { CSSProperties, useEffect, useRef, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  getColor,
  Icons,
  InfiniteScrollBox,
  InputField,
  Modal,
  Tabs,
  Tooltip,
  Typography,
  useToast,
  Avatargroup,
} from "fds";
import "./index.scss";
import { t, use } from "i18next";
import utilsCommon from "../../shared/utils/common";
import { DocDetailDto, LogItem, RevisionMap, SignMap } from "../../types/files";
import utilsDocs from "../../shared/utils/docs";
import RevisionTag from "../RevisionTag";
import useDocumentStore from "../../redux/dispatcher/useDocumentStore";
import Progress from "../../pages/Prgress";
import {
  gotoEditMode,
  handleDocDownload,
  handleDocPreview,
} from "../../shared/utils/api";
import { nanoid } from "@reduxjs/toolkit";
import ReadRequestModal from "../More/ReadRequestModal";
import PolicyToolTip from "../PolicyToolTip";
import DocLogHistory from "../DocAside/DocLogHistory";
import AuthDotIcon from "../AuthDotIcon";
import ChangeWorkgroupFileAuthModal from "../More/ChangeWorkgroupFileAuthModal";
import ChangeFileAuthModal from "../More/ChangeFileAuthModal";
import WorkgroupAvatar from "../WorkgroupAvatar";
import usePolicyStore from "../../redux/dispatcher/usePolicyStore";
import { getUserInfoFromLocalStorage } from "../../shared/utils/auth";
import { LoginDto } from "../../types/auth";
import utilsClient from "../../shared/utils/client";
import { ColumnDatas } from "@front/fds2.0-green/dist/src/components/atom/Tabs";
interface DocDetailModalProps {
  documentInfo?: DocDetailDto;
  open: boolean;
  onClose: () => void;
  actionUrl?: string;
  classes?: string;
  isClient?: boolean;
  style?: CSSProperties;
}
const copy = require("clipboard-copy");

const DocDetailModal: React.FC<DocDetailModalProps> = ({
  documentInfo,
  open,
  actionUrl,
  onClose,
  classes,
  isClient,
  style,
}) => {
  const commentListNewCard = useRef([] as any[]);

  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);
  const { getLinkFilePolicy } = usePolicyStore();
  const toast = useToast();
  const {
    documentState,
    getContentFavorite,
    getContentDownload,
    addContentMemo,
    getContentMemo,
  } = useDocumentStore();
  const [extraModal, changeExtraModal] = useState("CLOSE");
  const [tab, changeTab] = useState(0);
  const [comment, changeComment] = useState(""); // 새 의견
  const [key, setKey] = useState(0); // state용
  const canAddMemo =
    loginDto.userInfo.userId ===
      (
        documentInfo?.documentInfo?.master ??
        documentInfo?.documentInfo?.masterUser
      )?.userId?.toLowerCase() ||
    documentInfo?.documentInfo?.workgroup.workgroupId !== "NONEWORKGROUP";
  const tabs = [
    {
      text: t("file.detail"),
      color: "default",
    },
    {
      text: t("file.version"),
      isHidden: !canAddMemo || !loginDto || loginDto?.ecoUserInfo?.status !== 1,
      color: "default",
    },
    {
      text: t("file.action.comments"),
      color: "default",
      isHidden:
        !utilsCommon.checkMenuAvailble(
          "leaveComment",
          documentInfo?.documentInfo
        ) ||
        !loginDto ||
        loginDto?.ecoUserInfo?.status !== 1,
    },
  ] as ColumnDatas[];

  useEffect(() => {
    let newDataCardContent = [] as any[];
    documentState?.memos?.revisions?.revision.forEach(
      (item: RevisionMap, index: number) => {
        item?.signs?.sign?.map((item1) =>
          newDataCardContent.push(getTableCardData(item1, index))
        );
      }
    );
    commentListNewCard.current = newDataCardContent;
    setKey(key + 1);
  }, [documentState?.memos]);
  useEffect(() => {
    if (!documentInfo?.documentInfo?.syncId) return;
    if (tab === 2) {
      getContentMemo({ syncId: documentInfo?.documentInfo?.syncId });
    }
  }, [documentInfo?.documentInfo?.syncId, tab]);
  const handleCopyLink = () => {
    if (actionUrl) {
      if (utilsCommon.isClientLogin("MAC")) {
        utilsClient.copyLink(actionUrl);
      } else {
        copy(actionUrl);
      }

      toast.toastMsg(nanoid(), t("file.link.copySuccess"), "success");
    } else if (documentInfo) {
      getLinkFilePolicy({
        workgroupId: documentInfo?.documentInfo?.workgroup.workgroupId,
        syncId: documentInfo?.documentInfo?.syncId,
      }).then((resp: any) => {
        if (utilsCommon.isClientLogin("MAC")) {
          utilsClient.copyLink(resp.payload?.actionUrl);
        } else {
          copy(resp.payload?.actionUrl);
        }
        toast.toastMsg(nanoid(), t("file.link.copySuccess"), "success");
      });
    }
  };

  /** UI: 의견 테이브틀 리스트 */
  const getTableCardData = (item1: SignMap, index: any) => {
    return {
      id: item1?.signDate,
      data: (
        <Box classes="commentModal-comment">
          <Box alignItems="center">
            <Avatar
              uniqueCode={utilsCommon.getUserColor(item1.userType)}
              name={item1.userName}
              size={"32"}
            />
            <Tooltip message={item1.userName} maxWidth={"calc(100% - 200px)"}>
              <Typography classes="mg ml-4" type="subtitle2" ellipsis>
                {item1.userName}
              </Typography>
            </Tooltip>
            <Typography
              classes="mg ml-4"
              type="body4_rg"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {utilsCommon.renderDateFormat(item1.signDate)}
            </Typography>
          </Box>
          <Box classes="commentModal-comment--msg">
            <Typography type="body2_rg"> {item1.memo}</Typography>
          </Box>
        </Box>
      ),
    };
  };
  /** UI: 문서의 내 권한 */
  const renderDocAuth = () => {
    const myPolicy = documentInfo?.documentInfo?.myPolicy;
    const auth = !myPolicy
      ? "NONE"
      : myPolicy.uniqueId === "MASTER"
      ? "MASTER"
      : myPolicy.targetType === "USER"
      ? "IND"
      : "WORKGROUP";
    const authTitle = {
      MASTER: t("file.policy.master"),
      WORKGROUP: t("file.policy.workgroup"),
      IND: t("file.policy.ind"),
      NONE: t("file.policy.none"),
    };
    return (
      <PolicyToolTip
        policy={{
          ...myPolicy,
          targetType: myPolicy?.targetType ?? "IND",
          changeCode: "LOGIN",
          policy: myPolicy?.policy,
        }}
        targetAuth={auth}
        docInfo={documentInfo?.documentInfo}
      >
        <Box alignItems={"center"} classes={"mg mt-8"}>
          <AuthDotIcon auth={auth} style={{ marginRight: "3px" }} />
          <Typography type="subtitle2">{authTitle[auth]}</Typography>
        </Box>
      </PolicyToolTip>
    );
  };
  const renderDocInfo = () => {
    const isReceived =
      documentInfo?.documentInfo?.workgroup?.workgroupId === "NONEWORKGROUP" &&
      documentInfo.documentInfo.myPolicy?.uniqueId !== "MASTER";
    return (
      <Box direction="column">
        <Box classes="docDetailModal-header">
          <Typography
            type="body4_rg"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("common.common")}
          </Typography>
        </Box>
        <Box direction="column" width={"100%"}>
          <Box width={"100%"}>
            {!isReceived && (
              <Box direction="column" width={"calc(50% - 10px)"}>
                <Typography type="subtitle2">{t("file.master")}</Typography>
                <Tooltip
                  message={utilsCommon.getUserNameIdTag(
                    documentInfo?.documentInfo?.master?.userId ?? "",
                    documentInfo?.documentInfo.master?.userName
                  )}
                  maxWidth={"100%"}
                >
                  <Typography type="body2_rg" classes="mg mt-8 ellipse-2line">
                    {utilsCommon.getUserNameIdTag(
                      documentInfo?.documentInfo?.master?.userId ?? "",
                      documentInfo?.documentInfo.master?.userName
                    )}
                  </Typography>
                </Tooltip>
              </Box>
            )}
            <Box
              direction="column"
              width={"calc(50% - 10px)"}
              classes="mg m-20"
            >
              <Typography type="subtitle2">
                {documentInfo?.documentInfo?.workgroup?.workgroupId ===
                "NONEWORKGROUP"
                  ? t("file.sendDate")
                  : t("file.uploadTime")}
              </Typography>
              <Typography type="body2_rg" classes="mg mt-8">
                {utilsCommon.renderDateFormat(
                  documentInfo?.documentInfo.createTime
                )}
              </Typography>
            </Box>
            {isReceived && (
              <Box direction="column" width={"calc(50% - 10px)"}>
                <Typography type="subtitle2">{t("file.lastUpdate")}</Typography>
                <Typography type="body2_rg" classes="mg mt-8">
                  {utilsCommon.renderDateFormat(
                    documentInfo?.documentInfo.updateTime
                  )}
                </Typography>
              </Box>
            )}
          </Box>
          {!isReceived && (
            <Box width={"100%"} classes="mg mt-20">
              <Box direction="column" width={"calc(50% - 10px)"}>
                <Typography type="subtitle2">
                  {documentInfo?.documentInfo.concurrentUserId
                    ? t("file.checkinUser")
                    : t("file.reviser")}
                </Typography>
                {documentInfo?.documentInfo.concurrentUserId ? (
                  <Tooltip
                    message={utilsCommon.getUserNameIdTag(
                      documentInfo?.documentInfo?.concurrentUserId ?? "",
                      documentInfo?.documentInfo.checkoutUser.userName
                    )}
                    maxWidth={"100%"}
                  >
                    <Typography type="body2_rg" classes="mg mt-8 ellipse-2line">
                      {utilsCommon.getUserNameIdTag(
                        documentInfo?.documentInfo?.concurrentUserId ?? "",
                        documentInfo?.documentInfo.checkoutUser.userName
                      )}
                    </Typography>
                  </Tooltip>
                ) : (
                  <Tooltip
                    message={utilsCommon.getUserNameIdTag(
                      documentInfo?.documentInfo?.checkinUser?.userId ?? "",
                      documentInfo?.documentInfo.checkinUser?.userName
                    )}
                    maxWidth={"100%"}
                  >
                    <Typography type="body2_rg" classes="mg mt-8 ellipse-2line">
                      {utilsCommon.getUserNameIdTag(
                        documentInfo?.documentInfo?.checkinUser?.userId ?? "",
                        documentInfo?.documentInfo.checkinUser?.userName
                      )}
                    </Typography>
                  </Tooltip>
                )}
              </Box>
              <Box
                direction="column"
                width={"calc(50% - 10px)"}
                classes="mg m-20"
              >
                <Typography type="subtitle2">{t("file.lastUpdate")}</Typography>
                <Typography type="body2_rg" classes="mg mt-8">
                  {utilsCommon.renderDateFormat(
                    documentInfo?.documentInfo.updateTime
                  )}
                </Typography>
              </Box>
            </Box>
          )}
          <Box classes="docDetailModal-header mg mt-20">
            <Typography
              type="body4_rg"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("file.myPolicy")}
            </Typography>
          </Box>
          <Box width={"100%"}>
            <Box direction="column" width={"calc(50% - 10px)"}>
              {renderDocAuth()}
            </Box>
          </Box>

          {documentInfo?.documentInfo.workgroup.workgroupId !==
          "NONEWORKGROUP" ? (
            <Box width={"100%"} direction="column">
              <Box classes="docDetailModal-header mg mt-20">
                <Typography
                  type="body4_rg"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("file.authWorkgroupMember")}
                </Typography>
                <Button
                  leadingIcon={<Icons variant="fill" label="plusCircle" />}
                  btnStyle="icon"
                  onClick={() => changeExtraModal("CHANGE_WOKRGROUP_FILE_AUTH")}
                />
              </Box>
              <Box width={"100%"}>
                <Box alignItems="center" width={"calc(50% - 10px)"}>
                  <WorkgroupAvatar
                    item={documentInfo?.documentInfo.workgroup}
                    type="normal"
                    size="20"
                  />
                  <Tooltip
                    message={documentInfo?.documentInfo.workgroup.workgroupName}
                    classes="mg ml-8"
                    maxWidth={"calc(100% - 50px)"}
                  >
                    <Typography type="body2_rg" ellipsis>
                      {documentInfo?.documentInfo.workgroup.workgroupName}
                    </Typography>
                  </Tooltip>
                </Box>
                <Tooltip
                  message={documentInfo?.documentInfo?.workgroup?.members
                    ?.map((item) => item?.userName || item?.userId)
                    ?.join(", ")}
                >
                  <Avatargroup
                    visibleLength={8}
                    size="32"
                    items={utilsCommon.sortMembersToAvatarGroup(
                      documentInfo?.documentInfo.workgroup?.members
                    )}
                  />
                </Tooltip>
              </Box>
            </Box>
          ) : (
            documentInfo?.documentInfo.myPolicy?.uniqueId === "MASTER" && (
              <Box width={"100%"} direction="column">
                <Box classes="docDetailModal-header mg mt-20">
                  <Typography
                    type="body4_rg"
                    exactColor={getColor("COLOR_TEXT_SECONDARY")}
                  >
                    {t("sendingFile.permissionUser")}
                  </Typography>
                  <Button
                    leadingIcon={
                      <Icons
                        variant="fill"
                        label="plusCircle"
                        stroke={getColor("COLOR_ICON_INTERACTIVE_TERTIARY")}
                      />
                    }
                    btnStyle="icon"
                    onClick={() => changeExtraModal("CHANGE_FILE_AUTH")}
                  />
                </Box>
                <Box width={"100%"}>
                  <Tooltip
                    message={documentInfo?.permissionPolicyList
                      ?.map((item) => item.userName || item.targetValue)
                      ?.join(", ")}
                  >
                    <Avatargroup
                      visibleLength={8}
                      size="32"
                      items={utilsCommon.sortMembersToAvatarGroup(
                        documentInfo?.permissionPolicyList as any
                      )}
                    />
                  </Tooltip>
                </Box>
              </Box>
            )
          )}
        </Box>
      </Box>
    );
  };
  /** 의견 남기기 */
  const handleLeaveComment = () => {
    const syncId = documentInfo?.documentInfo?.syncId ?? "";
    const revisionNo = documentInfo?.documentInfo?.revisionNo ?? 0;
    addContentMemo({
      memo: comment,
      pushSign: true,
      revisionNo: revisionNo,
      syncId: syncId,
    });
    changeComment("");
  };
  const renderOfficeType = (type: "view" | "edit") => {
    const fileName = documentInfo?.documentInfo?.contentName;
    const fileType = fileName
      ? fileName.substring(fileName.lastIndexOf(".") + 1)
      : "";

    if (!window.eco.isCspp) {
      return type === "view" ? t("file.action.preview") : t("file.webCheckout");
    }
    if (["docx", "doc"].includes(fileType)) {
      return t(
        type === "view" ? "file.onlineOfficeView" : "file.onlineOfficeCheckout",
        { office: "Microsoft Word" }
      );
    } else if (["pptx", "ppt"].includes(fileType)) {
      return t(
        type === "view" ? "file.onlineOfficeView" : "file.onlineOfficeCheckout",
        { office: "Microsoft PowerPoint" }
      );
    } else if (["xlsx", "xls"].includes(fileType)) {
      return t(
        type === "view" ? "file.onlineOfficeView" : "file.onlineOfficeCheckout",
        { office: "Microsoft Excel" }
      );
    } else {
      return type === "view" ? t("file.action.preview") : t("file.webCheckout");
    }
  };
  const renderComment = () => {
    return (
      <Box direction="column" width={"calc(100% + 4px)"} height={"100%"}>
        <Box width={"calc(100% -4px)"} classes="mg mt-4">
          <InputField
            placeholder={t("file.commentPlaceholder")}
            size="md"
            width={"calc(100% - 97px)"}
            maxLength={512}
            value={comment}
            onChange={(e) => changeComment(e.target.value)}
            onKeyUp={(e) =>
              e.code === "Enter" && comment.length !== 0 && handleLeaveComment()
            }
            disabled={
              documentInfo?.documentInfo?.myPolicy?.uniqueId === "ONLYVIEW"
            }
          />
          <Button
            btnStyle="fill"
            label={t("common.post")}
            classes="mg ml-8"
            size="lg"
            state={comment.length === 0 ? "disable" : "default"}
            width={89}
            onClick={handleLeaveComment}
          />
        </Box>

        <InfiniteScrollBox
          height="100%"
          id="commentModal-comments"
          classes="commentModal-comments"
          data={commentListNewCard.current}
          endReached={() =>
            documentInfo?.documentInfo?.syncId &&
            documentState?.memos.nextcursor > -1 &&
            getContentMemo({
              syncId: documentInfo.documentInfo?.syncId,
              cursor: documentState?.memos?.nextcursor,
              revisionNo: documentState?.memos?.nextRevisionNo,
            })
          }
        />
      </Box>
    );
  };
  const renderDocDetailBody = (documentInfo: DocDetailDto) => {
    return (
      <Box direction="column" width={"100%"} height={"100%"}>
        {extraModal === "READ_REQUEST" && (
          <ReadRequestModal
            open={extraModal === "READ_REQUEST"}
            onClose={() => changeExtraModal("CLOSE")}
            docInfo={documentInfo.documentInfo}
          />
        )}
        {extraModal === "CHANGE_WOKRGROUP_FILE_AUTH" && (
          <ChangeWorkgroupFileAuthModal
            open={extraModal === "CHANGE_WOKRGROUP_FILE_AUTH"}
            onClose={() => changeExtraModal("CLOSE")}
            docInfos={
              documentInfo?.documentInfo
                ? [documentInfo?.documentInfo]
                : undefined
            }
          />
        )}
        {extraModal === "CHANGE_FILE_AUTH" && (
          <ChangeFileAuthModal
            open={extraModal === "CHANGE_FILE_AUTH"}
            onClose={() => changeExtraModal("CLOSE")}
            docInfo={documentInfo?.documentInfo}
          />
        )}
        <Box classes="mg mb-16">
          {utilsDocs.renderDocIcon(documentInfo?.documentInfo.contentName, 40)}
          <Box
            direction="column"
            classes="mg ml-8 mr-20"
            style={{ flex: 1, minWidth: 0 }}
          >
            <Tooltip message={documentInfo?.documentInfo.contentName}>
              <Typography type="body1_rg" ellipsis>
                {documentInfo?.documentInfo.contentName}
              </Typography>
            </Tooltip>
            <Box>
              <Typography
                type="body4_rg"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {`${utilsDocs.fileSizeFormat(
                  documentInfo?.documentInfo.fileSize
                )} · ${utilsDocs.fileFormattoStr(
                  documentInfo?.documentInfo.contentName
                )}`}
              </Typography>
              <RevisionTag
                classes="mg ml-8"
                revisionNo={documentInfo?.documentInfo.revisionNo}
              />
            </Box>
          </Box>
          <Box classes="mg ml-auto">
            <Tooltip
              message={
                !!documentInfo?.documentInfo?.favoritDate &&
                documentInfo?.documentInfo?.favoritDate > 0
                  ? t("file.action.removeFav")
                  : t("file.action.addFav")
              }
            >
              <Button
                btnStyle="icon"
                onClick={() =>
                  getContentFavorite({
                    syncIds: [documentInfo?.documentInfo?.syncId],
                    flag: documentInfo?.documentInfo?.favoritDate <= 0,
                    page: "favorite",
                  })
                }
                leadingIcon={
                  !!documentInfo?.documentInfo?.favoritDate &&
                  documentInfo?.documentInfo?.favoritDate > 0 ? (
                    <Icons variant="fill" label="star" isColored size={20} />
                  ) : (
                    <Icons variant="line" label="star" isOn size={20} />
                  )
                }
              />
            </Tooltip>
            {utilsCommon.checkMenuAvailble(
              "preview",
              documentInfo.documentInfo
            ) && (
              <Tooltip message={renderOfficeType("view")} classes="mg ml-4">
                <Button
                  btnStyle="icon"
                  leadingIcon={
                    <Icons variant={"line"} label={"preview"} isOn />
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDocPreview({
                      permission: "view",
                      workgroupId:
                        documentInfo.documentInfo.workgroup.workgroupId,
                      syncId: documentInfo.documentInfo.syncId,
                      toast,
                      t,
                      revisionNo: 0,
                    });
                  }}
                />
              </Tooltip>
            )}
            {utilsCommon.checkMenuAvailble(
              "editMode",
              documentInfo.documentInfo
            ) && (
              <Tooltip message={renderOfficeType("edit")} classes="mg ml-4">
                <Button
                  btnStyle="icon"
                  leadingIcon={<Icons variant={"line"} label={"edit"} isOn />}
                  onClick={(e) => {
                    e.stopPropagation();
                    gotoEditMode(
                      documentInfo.documentInfo.workgroup.workgroupId,
                      documentInfo.documentInfo.syncId,
                      toast
                    );
                  }}
                />
              </Tooltip>
            )}
            <Tooltip message={t("file.action.download")} classes="mg ml-4">
              <Button
                btnStyle="icon"
                onClick={(e) => {
                  e.stopPropagation();
                  handleDocDownload(
                    documentInfo.documentInfo.syncId,
                    getContentDownload,
                    toast,
                    t,
                    "0",
                    documentInfo.documentInfo.contentName
                  );
                }}
                leadingIcon={<Icons variant={"line"} label={"download"} />}
              />
            </Tooltip>
            <Tooltip message={t("file.action.shareLink")} classes="mg ml-4">
              <Button
                btnStyle="icon"
                onClick={(e) => {
                  e.stopPropagation();
                  handleCopyLink();
                }}
                leadingIcon={<Icons variant={"line"} label={"link"} isOn />}
              />
            </Tooltip>
            {utilsCommon.checkMenuAvailble(
              "requestOpen",
              documentInfo.documentInfo
            ) && (
              <Tooltip message={t("file.action.requestOpen")} classes="mg ml-4">
                <Button
                  btnStyle="icon"
                  leadingIcon={
                    <Icons variant={"line"} label={"readRequest"} isOn />
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    changeExtraModal("READ_REQUEST");
                  }}
                />
              </Tooltip>
            )}
          </Box>
        </Box>
        <Tabs
          tabs={tabs}
          selected={tab}
          size={"md"}
          classes="mg mb-16 tab"
          selectTab={(tab) => changeTab(tab)}
        ></Tabs>
        {tab === 0 ? (
          renderDocInfo()
        ) : tab === 1 ? (
          <DocLogHistory documentInfo={documentInfo} />
        ) : (
          renderComment()
        )}
      </Box>
    );
  };
  return isClient && documentInfo ? (
    <Box style={{ padding: "20px 28px" }} classes="docDetailModal">
      {renderDocDetailBody(documentInfo)}
    </Box>
  ) : (
    <Modal
      open={open}
      onClose={onClose}
      title={t("file.link.fileInfo")}
      width={816}
      bodyHeight={556}
      classes="docDetailModal"
      isFooterDivider
      body={
        documentInfo ? (
          renderDocDetailBody(documentInfo)
        ) : (
          <Progress inProgress />
        )
      }
      footer={
        <Box>
          <Button btnStyle="fill" label={t("common.close")} onClick={onClose} />
        </Box>
      }
    />
  );
};
export default DocDetailModal;
